export const runnerAssessment = [
    {
        id: 'q1', question: 'Why do customers choose Sendrey?',
        options: [
            'To become runners', 
            'To buy products directly from Sendrey', 
            'To complete errands conveniently, reliably, and stress-free', 
            'To borrow money'
        ],
        correctIndex: 2
    },
    {
        id: 'q2', question: 'Which action helps build customer trust?',
        options: [
            'Ignoring customer messages', 
            'Following customer instructions and communicating honestly', 
            'Asking customers for extra payments', 
            'Completing errands whenever convenient'
        ],
        correctIndex: 1
    },
    {
        id: 'q3', question: 'A customer is upset because you\'re delayed due to heavy traffic. What should you do?',
        options: [
            'Ignore their messages until you arrive', 
            'Tell the customer it\'s not your fault', 
            'stay calm, explain the situation honestly and provide an updated arrival time', 
            'Abandon or Cancel the errand'
        ],
        correctIndex: 2
    },{
        id: 'q4', question: ' Which behavior should you NEVER display?',
        options: [
            'Handling customer items carefully', 
            'Following customer instructions', 
            'Respecting customer privacy',
            'Raising your voice during a disagreement' 
        ],
        correctIndex: 3
    },{
        id: 'q5', question: 'Why is professionalism important?',
        options: [
            'It allows you to ignore company policies', 
            'It builds trust and protects Sendrey\'s reputation',
            'It guarantees bigger tips', 
            'It helps you finish errands faster', 
        ],
        correctIndex: 1
    },{
        id: 'q6', question: 'You accidentally purchase the wrong item. What should you do?',
        options: [
            'Inform the customer, apologize where appropriate, explain honestly, and ask how they\'d like to proceed', 
            'Blame the supermarket', 
            'Hide the mistake', 
            'Deliver it anyway without saying anything'
        ],
        correctIndex: 0
    },{
        id: 'q7', question: 'Customers trust Sendrey runners with: ',
        options: [
            'Their belongings', 
            'Their personal information', 
            'Their money', 
            'All of the above'
        ],
        correctIndex: 3
    },{
        id: 'q8', question: 'A customer asks you to purchase groceries with your own money and promises to reimburse you later. What should you do?',
        options: [
            'Pay if the customer sounds trustworthy', 
            'Pay first to avoid delays', 
            'Explain that shopping tasks must be funded before purchases can be made', 
            'Pay if the total amount is small'
        ],
        correctIndex: 2
    },{
        id: 'q9', question: 'When should customers receive updates?',
        options: [
            'Throughout the errand, including delays, unavailable items, and completion', 
            'Only if they ask', 
            'Only after delivery', 
            'Never'
        ],
        correctIndex: 0
    },{
        id: 'q10', question: 'Which situation means you should stop working immediately?',
        options: [
            'Feeling slightly tired after several errands', 
            'Experiencing severe fatigue, dizziness, or feeling unwell', 
            'Having a slower-than-usual delivery', 
            'Finishing a long shopping task'
        ],
        correctIndex: 1
    },{
        id: 'q11', question: ' Which message is the most professional?',
        options: [
            'I have arrived at the store.', 
            'Good afternoon. I\'ve arrived and will begin shopping shortly. I\'ll let you know if any requested item is unavailable', 
            'I don reach.', 
            'I will finish as quickly as possible.'
        ],
        correctIndex: 1
    },{
        id: 'q12', question: 'Which habit helps you stay healthy while working?',
        options: [
            'Eating only after your shift ends', 
            'Working continuously to complete more errands', 
            'Riding for as long as possible before resting', 
            'Taking short breaks, staying hydrated, and getting enough rest'
        ],
        correctIndex: 3
    },{
        id: 'q13', question: 'If an item requested by the customer is unavailable, you should:',
        options: [
            'Remove the item and continue shopping without mentioning it', 
            'Inform the customer and wait for instructions', 
            'Cancel the task', 
            'Purchase the closest alternative.'
        ],
        correctIndex: 1
    },{
        id: 'q14', question: ' Which action is considered Gross Misconduct? ',
        options: [
            'Arriving late', 
            'Forgetting to send an update', 
            'Sharing customer information', 
            'Taking a short break'
        ],
        correctIndex: 2
    },{
        id: 'q15', question: 'Which of the following is NOT professional communication?',
        options: [
            'Sending one-word replies', 
            'Thanking the customer after completing the errand', 
            'Confirming customer instructions', 
            'Providing regular updates'
        ],
        correctIndex: 0
    },{
        id: 'q16', question: 'Why is good communication important?',
        options: [
            'It keeps customers informed', 
            'It reduces misunderstandings', 
            'All of the above', 
            'It builds customer trust'
        ],
        correctIndex: 2
    },{
        id: 'q17', question: 'Which of the following is considered Minor Misconduct?',
        options: [
            'Fraud', 
            'Poor communication', 
            'Physical assault', 
            'Theft'
        ],
        correctIndex: 1
    },{
        id: 'q18', question: 'A customer stops replying while you\'re shopping. What should you do?',
        options: [
            'Wait briefly, follow Sendrey\'s guidelines, and contact Support if necessary', 
            'Choose reasonable substitutes for every unavailable item', 
            'Skip any unavailable items and complete the errand immediately', 
            'Finish shopping without informing them'
        ],
        correctIndex: 0
    },{
        id: 'q19', question: 'Before riding, you should always:  ',
        options: [
            'Ignore traffic laws', 
            'Plan the fastest route to save time', 
            'Check that your motorcycle is roadworthy and wear your helmet', 
            'Begin riding immediately if you are running late.'
        ],
        correctIndex: 2
    },{
        id: 'q20', question: 'A customer asks you to mark the errand as completed before delivery because they "trust you." What should you do?',
        options: [
            'Ignore the customer', 
            'Mark it complete once you\'re close to the destination', 
            'Complete the task only after the delivery has actually been completed according to Sendrey\'s process', 
            'Do it and report the customer'
        ],
        correctIndex: 2
    },{
        id: 'q21', question: 'Which statement best reflects Sendrey\'s safety policy?',
        options: [
            'Deliveries are more important than safety', 
            'Finish every task regardless of your condition', 
            'Completed delivery is the highest priority', 
            'No delivery is more important than your life'
        ],
        correctIndex: 3
    },{
        id: 'q22', question: 'You discover your motorcycle has faulty brakes before starting work. What should you do?',
        options: [
            'Repair the motorcycle before accepting errands', 
            'Reduce your speed and continue working', 
            'Complete the current day\'s errands and repair it afterward', 
            'Ride only if the customer is nearby'
        ],
        correctIndex: 0
    },{
        id: 'q23', question: 'Threatening or behaving aggressively toward a customer is classified as:',
        options: [
            'Gross Misconduct', 
            'Acceptable behaviour', 
            'Major Misconduct', 
            'Minor Misconduct'
        ],
        correctIndex: 2
    },{
        id: 'q24', question: 'A customer offers to pay you directly instead of through Sendrey. What should you do?',
        options: [
            'Politely decline and ask the customer to use Sendrey\'s payment process', 
            'Accept the payment and inform Support afterward', 
            'Negotiate a higher amount', 
            'Accept only if the customer insists'
        ],
        correctIndex: 0
    },{
        id: 'q25', question: 'By completing this training and accepting errands on Sendrey, you agree to:',
        options: [
            'Set your own rules', 
            'Collect unauthorized payments whenever necessary', 
            'Ignore customer complaints', 
            'Follow Sendrey\'s policies and maintain professional standards'
        ],
        correctIndex: 3
    },
];